import { App, Feature, Menu, SpeedDial } from '@mairistem/module';
import { request } from '@mairistem/tools';
import React from 'react';
import { useHistory } from 'react-router';
import Autorisation from './components/autorisation/Autorisation';
import AutorisationModal from './components/autorisation/AutorisationModal';
import Context from './components/common/Context/Context';
import CreditPaiement from './components/creditPaiement/CreditPaiement';
import Dashboard from './components/dashboard/Dashboard';
import Pluriannuelle from './components/pluriannuelle/Pluriannuelle';
import DECISION from './constants/common/decision';
import STORAGE_KEY from './constants/common/storage';
import './AppApcp.css';

const AppApcp = () => {
	const handleAuth = () => {
		const params = new URLSearchParams(window.location.search);
		sessionStorage.setItem(
			STORAGE_KEY.ID_ENTITE,
			params.get(STORAGE_KEY.ID_ENTITE),
		);
		sessionStorage.setItem(
			STORAGE_KEY.ID_ENTITE_CPTA,
			params.get(STORAGE_KEY.ID_ENTITE_CPTA),
		);
	};

	return (
		<App
			code="HOL_APCP"
			context={Context}
			group="finances"
			name="APCP"
			onAuth={handleAuth}
			additionalProductCodesUpdate={['HOL_SIMU', '360_DEC']}
			request={request}
		>
			<Menu.Home>
				<Feature>
					<Feature.Content>
						<Dashboard />
					</Feature.Content>
				</Feature>
			</Menu.Home>
			<Menu icon="check-square" name="Autorisations de programme" path="/ap">
				<Feature>
					<Feature.Content>
						<Autorisation decision={DECISION.AP} />
					</Feature.Content>
				</Feature>
				<Feature path="/create">
					<Feature.Content>
						{() => {
							// biome-ignore lint/correctness/useHookAtTopLevel: On ne peut le mettre qu'ici
							const history = useHistory();

							return (
								<AutorisationModal
									decision={DECISION.AP}
									onClose={() => history.goBack()}
									onFinish={() => history.push('/ap')}
								/>
							);
						}}
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu icon="file-alt" name="Autorisations d'engagement" path="/ae">
				<Feature>
					<Feature.Content>
						<Autorisation decision={DECISION.AE} />
					</Feature.Content>
				</Feature>
				<Feature path="/create">
					<Feature.Content>
						{() => {
							// biome-ignore lint/correctness/useHookAtTopLevel: On ne peut le mettre qu'ici
							const history = useHistory();

							return (
								<AutorisationModal
									decision={DECISION.AE}
									onClose={() => history.goBack()}
									onFinish={() => history.push('/ae')}
								/>
							);
						}}
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu icon="credit-card" name="Crédits de paiement" path="/credit">
				<Feature>
					<Feature.Content>
						<CreditPaiement />
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu
				icon="chart-line"
				name="Programmation pluriannuelle"
				path="/pluriannuelle"
			>
				<Feature>
					<Feature.Content>
						<Pluriannuelle />
					</Feature.Content>
				</Feature>
			</Menu>
			<SpeedDial>
				<SpeedDial.Button
					dataTestId="createAP"
					icon="check-square"
					name="create_ap"
					path="/ap/create"
					title="Créer une APCP"
				/>
				<SpeedDial.Button
					dataTestId="createAE"
					icon="file-alt"
					name="create_ae"
					path="/ae/create"
					title="Créer une AECP"
				/>
			</SpeedDial>
		</App>
	);
};

export default AppApcp;
